module.exports = __webpack_public_path__ + "images/money_button-1e0e46b7.svg";